import { environment } from './../../../../environments/environment';
import { Component, ElementRef, ViewChild, OnInit } from "@angular/core";
import { fuseAnimations } from "../../../core/animations";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as pbi from "powerbi-client";
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';
import { ConstantesService } from '../../../core/constantes/constantes.service';
import { Observable } from 'rxjs/Observable';
import { ActivosService } from '../activos/activos.service';

@Component({
  selector: "fuse-general-dashboard",
  templateUrl: "./general-dashboard.component.html",
  styleUrls: ["./general-dashboard.component.scss"],
  animations: fuseAnimations,
})
export class GeneralDashboardComponent implements OnInit {
  private groupId: string;
  reportId: string;

  @ViewChild("reportContainer") reportContainer: ElementRef;

  constructor(
    private http: HttpClient,
    private notificaciones: NotificacionesService,
    private constantes: ConstantesService,
    private activosService: ActivosService
  ) {
    // Group Id
    this.groupId = environment.powerbi.groupId;
    // Report Id
    this.reportId = JSON.parse(
      sessionStorage.getItem("usuarioLogueado")
    ).usuario.cliente.general_powerbi;

    // notify about the new activo (it could be null)
    this.activosService.setCurrentActivo(undefined);
  }

  ngOnInit() {
    if (this.reportId) {
      // First off, we need an access token for the power bi pro user
      this.getAccessToken().subscribe(
        (res: { access_token: string }) => {
          const { access_token } = res;
          // Then, we need an embed token in order to embed in our app the report provided
          this.getEmbedToken(access_token).subscribe(
            (res: { token: string }) => {
              const { token } = res;
              // Finally, we render the report
              this.showReport(token);
            },
            (err) => {
              if (err.status === 404) {
                this.notificaciones.mostrarAviso(
                  this.notificaciones.mensajes.IdiomaActual.Activos.PowerBi
                    .NOEncontrado
                );
              } else {
                console.error(err.message);
                this.notificaciones.mostrarAviso(err.message);
              }
            }
          );
        },
        (err) => {
          console.error(err);
          this.notificaciones.mostrarAviso(err.error.error_description);
        }
      );
    } else {
      this.notificaciones.mostrarAviso(
        this.notificaciones.mensajes.IdiomaActual.Activos.PowerBi.NOEncontrado
      );
    }
  }

  getAccessToken(): Observable<Object> {
    return this.http.get(
      environment.urlBase + "getAccessToken",
      this.constantes.httpOptions
    );
  }

  getEmbedToken(accessToken: string): Observable<Object> {
    return this.http.get(
      environment.urlBase + `getEmbedToken/${accessToken}/${this.reportId}`,
      this.constantes.httpOptions
    );
  }

  showReport(embedToken: string) {
    const config = {
      type: "report",
      accessToken: embedToken,
      embedUrl: "https://app.powerbi.com/reportEmbed",
      tokenType: pbi.models.TokenType.Embed,
      id: this.reportId,
      permissions: pbi.models.Permissions.All,
      settings: {
        localeSettings: {
          language: "en",
          formatLocale: "es",
        },
      },
    };

    // Grab the reference to the div HTML element that will host the report.
    const reportContainer = this.reportContainer.nativeElement;

    // Embed the report and display it within the div container.
    const powerbi = new pbi.service.Service(
      pbi.factories.hpmFactory,
      pbi.factories.wpmpFactory,
      pbi.factories.routerFactory
    );
    const report = powerbi.embed(reportContainer, config);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/general-dashboard/general-dashboard.component.ts